import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { BarChart3 } from "lucide-react";
import AnimatedSection from "./AnimatedSection";

const DaCta: React.FC = () => (
  <AnimatedSection as="section" className="da-cta" aria-labelledby="da-cta-title">
    <div className="da-container">
      <motion.div
        className="da-cta__inner"
        whileHover={{ scale: 1.005 }}
        transition={{ duration: 0.3 }}
      >
        <div className="da-cta__icon" aria-hidden="true">
          <BarChart3 size={32} />
        </div>
        <div className="da-cta__text">
          <h2 id="da-cta-title">Ready To Unlock Your Data&apos;s Potential?</h2>
          <p>Let&apos;s build an analytics strategy that drives measurable business impact.</p>
        </div>
        <div className="da-cta__actions">
          <Link to="/contact" className="da-cta__btn da-cta__btn--primary">
            Get Free Consultation
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Link>
          <Link to="/contact" className="da-cta__btn da-cta__btn--ghost">
            Request a Demo
          </Link>
        </div>
      </motion.div>
    </div>
  </AnimatedSection>
);

export default DaCta;
